<template>
    <div class="relative flex flex-col flex-1 min-h-0 bg-stage-background overflow-hidden">
        <div class="stage-page-header">
            <div class="stage-page-header-row">
                <div class="stage-page-header-main">
                    <div class="flex flex-wrap items-center gap-2">
                        <h1 class="stage-page-title">{{ $t('System extensions') }}</h1>
                        <div class="stage-shortcut-badges">
                            <span
                                v-for="badge in $navigationShortcutBadges('system_extensions')"
                                :key="badge.key"
                                :title="badge.title || 'Shortcut'"
                                class="stage-shortcut-badge"
                            >
                                <svg-vue class="stage-shortcut-badge-icon" icon="font-awesome.solid.command"></svg-vue>
                                {{ badge.label }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="stage-page-body stage-page-fill">
            <div class="w-full h-full bg-white shadow sm:rounded relative overflow-hidden flex flex-col min-h-0">
                <div class="flex-1 min-h-0 overflow-auto p-4 sm:p-6">
                    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                        <router-link
                            v-for="extension in visibleExtensions"
                            :key="extension.id"
                            :to="extension.route"
                            class="group flex min-h-[10rem] items-start border border-bordergray-100 bg-white p-5 transition-colors duration-200 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 sm:rounded"
                        >
                            <div class="mr-4 flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-gray-700">
                                <svg-vue class="h-9 w-9 p-2 text-gray-200" :icon="extension.icon"></svg-vue>
                            </div>
                            <div class="min-w-0 flex-1">
                                <h2 class="text-base font-medium text-gray-700">
                                    {{ $t(extension.title) }}
                                </h2>
                                <p class="mt-2 text-sm leading-5 text-gray-500">
                                    {{ $t(extension.description) }}
                                </p>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {resolveStoreAccess} from '@/utils/access-context';
import {TEMPLATE_FAMILIES} from '@/utils/template-profiles';

export default {
    name: 'workspace-system-extensions-index',
    metaInfo() {
        return {
            title: this.$t('System extensions'),
        };
    },
    computed: {
        accessContext() {
            return resolveStoreAccess(this.$store);
        },
        visibleExtensions() {
            const modules = this.accessContext.modules || {};
            const extensions = [];

            if (modules.cms && this.accessContext.template_family === TEMPLATE_FAMILIES.INTERNAL) {
                extensions.push({
                    id: 'cms',
                    title: 'CMS',
                    description: 'Manage websites, pages, templates and reusable content modules.',
                    icon: 'font-awesome.regular.window-restore',
                    route: '/workspace/cms',
                });
            }

            if (modules.insights) {
                extensions.push({
                    id: 'insights',
                    title: 'Insights',
                    description: 'Monitor servers, hosts and connected infrastructure.',
                    icon: 'font-awesome.regular.monitor-waveform',
                    route: this.accessContext.template_family === TEMPLATE_FAMILIES.CUSTOMER
                        ? '/insights/server-monitoring'
                        : '/workspace/insights',
                });
            }

            return extensions;
        },
    },
};
</script>
